import {
  setItem,
  getItem,
  removeitem,
  setItemId,
  getItemId,
  removeitemId,
  getUsername,
  setUsername,
  removeUsername,
  getUser,
  setUser,
  removeUser
} from '@/utils/auth';
const user = {
  namespaced: true,
  state: {
    token: getItem('x-Token') || null,
    id: getItemId('id') || null,
    username: getUsername('username') || null,
    user: getUser('user') || {},
    searchKeyword: null
  },
  mutations: {
    // 保存token方法
    SET_TOKEN_INFO(state, token) {
      state.token = token
      setItem('x-Token', token)
    },
    // 保存ID方法
    SET_ID_INFO(state, id) {
      state.id = id
      setItem('id', id)
    },
    // 保存username方法
    SET_USER_NAME(state, username) {
      state.username = username
      setItem('username', username)
    },

    // 保存user方法
    SET_USER(state, user) {
      state.user = user
      setItem('user', user)
    },
    // 保存搜索关键词
    SET_SEARCH_KEYWORD(state, keyword) {
      state.searchKeyword = keyword
    },
    // 清除搜索关键词
    CLEAR_SEARCH_KEYWORD(state) {
      state.searchKeyword = null
    },





    // 删除token
    REMOVE_TOKEN_INFO(state, token) {
      state.token = token
      removeitem('x-Token')
    },
    // 删除ID
    REMOVE_ID_INFO(state, username) {
      state.name = username
      removeitem('username')
    },
    // 删除username
    REMOVE_USER_NAME(state, username) {
      state.name = username
      removeitem('username')
    },


    // 删除user
    REMOVE_USER(state, user) {
      state.user = user
      removeitem('user')
    },
    // 退出登录，清除所有信息
    LOGOUT(state) {
      state.token = null;
      state.id = null;
      state.username = null;
      state.user = {};
      removeitem('x-Token');
      removeitem('id');
      removeitem('username');
      removeitem('user');
    },
  },
  actions: {

  }
}



export default user